'use client';

import React from 'react';

interface FilterIconProps {
  width?: number | string;
  height?: number | string;
  color?: string;
  className?: string;
}

export const FilterIcon: React.FC<FilterIconProps> = ({
  width = 20,
  height = 20,
  color = 'currentColor',
  className,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 20 20"
      className={className}
    >
      <path
        fill={color}
        d="M11.666 10v6.567a.8.8 0 0 1-.241.691.83.83 0 0 1-1.175 0l-1.675-1.675a.83.83 0 0 1-.242-.691V10h-.025l-4.8-6.15a.833.833 0 0 1 .142-1.167.87.87 0 0 1 .516-.183h11.667c.183 0 .358.067.517.183a.833.833 0 0 1 .141 1.167l-4.8 6.15z"
      />
    </svg>
  );
};

